import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { ReadActionKey } from 'owa-outlook-service-options';
import { updateContextMenuItem } from '../utils/updateContextMenuItem';

export default function getFilterableMailListContextMenuItems(
    rowKeys: string[],
    tableViewId: string,
    onDismiss: (ev?: any) => void,
    menuKeysInOrder: ReadActionKey[]
): FilterableMenuItem[] {
    let mailListContextMenuItems: FilterableMenuItem[] = [];
    menuKeysInOrder.forEach(key => {
        mailListContextMenuItems.push(
            createFilterableContextMenuItem(key, rowKeys, tableViewId, onDismiss)
        );
    });

    return mailListContextMenuItems;
}

export function createFilterableContextMenuItem(
    key: ReadActionKey,
    rowKeys: string[],
    tableViewId: string,
    onDismiss: (ev?: any) => void
) {
    const filterableMenuItem = new FilterableMenuItem({ [FilterableMenuItemArgs.name]: key });

    updateContextMenuItem[key as ReadActionKey](
        rowKeys,
        tableViewId,
        onDismiss,
        filterableMenuItem
    );

    if (filterableMenuItem.subMenuKeys) {
        const subMenuItems = getFilterableMailListContextMenuItems(
            rowKeys,
            tableViewId,
            onDismiss,
            filterableMenuItem.subMenuKeys
        );

        filterableMenuItem.subMenuProps = subMenuItems
            ? { items: subMenuItems.filter((item: FilterableMenuItem) => item.shouldShow()) }
            : null;
    }
    return filterableMenuItem;
}
